import { Stack } from '@mui/material'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormatNumbers } from '../../../hooks/useFormatNumbers'
import { setQuantityLiters, setSubTotal, setSubTotalEstacionario } from '../../../slices/orderSlice'
import { customStyles, spaceBetween } from '../../../styles'
import { RegularText } from '../../helpers'

export const InfoEstacionario = (props) => {
  const { error, setError } = props
  const { service, quantity, subTotal, isByCost } = useSelector(state => state.order)
  const { data } = useSelector(state => state.products)
  const { id, price } = data.length > 0 && data[0]
  const sTotal = useFormatNumbers(subTotal)

  const dispatch = useDispatch()
  useEffect(() => {
    if(data.length > 0) {
      if(isByCost){
        dispatch(setQuantityLiters({isByCost, qt:500}))
        dispatch(setSubTotalEstacionario(500))
      } else {
        
        dispatch(setQuantityLiters({isByCost, qt:50}))
        dispatch(setSubTotalEstacionario(data[0].price))
      }
    }
  }, [data, isByCost])

  useEffect(() => {
    const pSubTotal = parseInt(subTotal)
    const pQuantity = parseInt(quantity)
    if(isByCost){
      if( pSubTotal < 500 || pSubTotal > 10000 ) {
        setError(true)
        return
      } 
    } else if( pQuantity < 50 || pSubTotal < 50 || pSubTotal > 10000) {
      setError(true)
      return
    }
    setError(false)
  }, [subTotal, quantity, dispatch])
  return (
    <Stack spacing={3} mt={10}>
      {
        error&&
          <RegularText bold component={ <RegularText align="center" text="La cantidad tiene que ser mayor a $500 y menor a $10,000" color={customStyles.colors.red}/> } sx={ spaceBetween }/>
        }
      <RegularText text="Precio por cilindro" bold component={ <span>${price} lt</span> } sx={ spaceBetween }/>
      <RegularText text="Litros" bold component={ <span>{ quantity } lt</span> } sx={ spaceBetween }/>
      <RegularText text="Subtotal" color={customStyles.colors.main} bold component={ <span>${sTotal}</span> } sx={ spaceBetween }/>
    </Stack>
  )
}
